import { EVENT_COUNT_KEY } from '@esentai/core/features/applicationSettings/homeLayout/consts/payloadKeys';
import PropTypes from 'prop-types';
import React from 'react';

import TextField from '@/components/TextField';

const CalendarEvents = ({ Field }) => (
  <Field
    Target={TextField}
    name={EVENT_COUNT_KEY}
    label="Количество событий"
    type="number"
  />
);

CalendarEvents.propTypes = {
  Field: PropTypes.func.isRequired,
};

export default CalendarEvents;
